import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpIcon from '@mui/icons-material/Help';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useSelector } from 'react-redux';

function MobileBottomNavBar({ onRouteConfigOpen }) {
    const user = useSelector(state => state.auth.user);
    const location = useLocation();
    const [bottomNavValue, setBottomNavValue] = useState(0);

    // Update bottom navigation based on current route
    useEffect(() => {
        const path = location.pathname;
        if (user) {
            // Signed-in mobile navigation
            if (path === '/') setBottomNavValue(0);
            else if (path === '/help') setBottomNavValue(1);
            else if (path.startsWith('/cues/')) setBottomNavValue(2);
        } else {
            // Signed-out mobile navigation
            if (path === '/') setBottomNavValue(0);
            else if (path === '/pricing') setBottomNavValue(1);
            else if (path === '/help') setBottomNavValue(2);
            else if (path.startsWith('/cues/')) setBottomNavValue(3);
        }
    }, [location.pathname, user]);

    const handleBottomNavChange = (event, newValue) => {
        setBottomNavValue(newValue);
    };

    return (
        <BottomNavigation
            value={bottomNavValue}
            onChange={handleBottomNavChange}
            showLabels
            className="no-print"
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                backgroundColor: '#f2f2f2',
                borderTop: '1px solid #e0e0e0',
                '& .MuiBottomNavigationAction-root': {
                    color: '#666',
                    '&.Mui-selected': {
                        color: '#1976d2'
                    }
                }
            }}
        >
            {user ? (
                // Signed-in mobile navigation
                <>
                    <BottomNavigationAction
                        label="Home"
                        icon={<HomeIcon />}
                        component={Link}
                        to="/"
                    />
                    <BottomNavigationAction
                        label="Help"
                        icon={<HelpIcon />}
                        component={Link}
                        to="/help"
                    />
                    {location.pathname.startsWith('/cues/') && (
                        <BottomNavigationAction
                            label="Route Settings"
                            icon={<SettingsIcon />}
                            onClick={onRouteConfigOpen}
                        />
                    )}
                </>
            ) : (
                // Signed-out mobile navigation
                <>
                    <BottomNavigationAction
                        label="Home"
                        icon={<HomeIcon />}
                        component={Link}
                        to="/"
                    />
                    <BottomNavigationAction
                        label="Pricing"
                        icon={<AttachMoneyIcon />}
                        component={Link}
                        to="/pricing"
                    />
                    <BottomNavigationAction
                        label="Help"
                        icon={<HelpIcon />}
                        component={Link}
                        to="/help"
                    />
                    {location.pathname.startsWith('/cues/') && (
                        <BottomNavigationAction
                            label="Route Settings"
                            icon={<SettingsIcon />}
                            onClick={onRouteConfigOpen}
                        />
                    )}
                </>
            )}
        </BottomNavigation>
    );
}

export default MobileBottomNavBar;
